import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';

// cat. resources - locales (번들에 정적 포함되어 JS 청크 해시로 캐시 버스팅됨)
import koViewAdmin from 'locales/ko/view_admin.json';

const bundledResources = {ko: {view_admin: koViewAdmin}};

const i18nConfiguration = (callback) => {
    const language = 'ko';
    const isInitialized = i18next.isInitialized;

    const rawOverrides = (typeof window !== 'undefined' && window.INTO_SETTINGS && window.INTO_SETTINGS.L10n) || null;

    const isObj = (v) => v && typeof v === 'object' && !Array.isArray(v);
    const deepMerge = (target, source) => {
        if (!isObj(source)) return source ?? target;
        const out = {...(isObj(target) ? target : {})};
        Object.keys(source).forEach((k) => {
            const srcVal = source[k];
            const tgtVal = out[k];
            out[k] = isObj(srcVal) && isObj(tgtVal) ? deepMerge(tgtVal, srcVal) : srcVal;
        });
        return out;
    };

    const i18nextOptions = {
        resources: isInitialized ? i18next.store.data : bundledResources,

        /* Default Language */
        lng: language,

        /* fallback */
        fallbackLng: 'ko',

        /* 현재 언어만 Load */
        load: 'languageOnly',

        /* 사용할 Namespace List */
        ns: ['view_admin'],

        /* Default Namespace */
        defaultNS: 'view_admin',

        /* Debug */
        debug: false,

        /* Missing key 경고 숨김 */
        saveMissing: false,
        missingKeyHandler: false,

        /* 다국어에 동적 값을 통합 */
        interpolation: {
            escapeValue: false,
        },

        /* 리소스를 전부 번들에 포함하므로 backend 커넥터를 사용하지 않는다. true 로 바꾸면
           등록되지 않은 backendConnector 로 라우팅되므로 반드시 false 를 유지할 것 */
        partialBundledLanguages: false,

        react: {
            wait: true,
            useSuspense: false,
            withRef: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default',
        },
    };

    i18next
        .use(initReactI18next)
        .init(i18nextOptions, () => {
            if (rawOverrides && isObj(rawOverrides)) {
                const ns = i18nextOptions.defaultNS || 'view_admin';

                Object.keys(rawOverrides).forEach((lng) => {
                    const overrideNSPayload = rawOverrides[lng];
                    if (!isObj(overrideNSPayload)) return;

                    const existing =
                        (i18next.hasResourceBundle(lng, ns)
                            ? i18next.getResourceBundle(lng, ns)
                            : {}) || {};

                    const merged = deepMerge(existing, overrideNSPayload);

                    i18next.addResourceBundle(
                        lng,
                        ns,
                        merged,
                        true,
                        true
                    );
                });
            }

            callback && callback();
        })
        .then();
};

export default i18nConfiguration;
